export default "__VITE_ASSET__IvPSus1P__"